import { LOGO_DARK_SRC, LOGO_LIGHT_SRC, SITE_NAME, getPublicSiteUrl } from '@/lib/site';
import { absoluteUrl } from '@/lib/seo';

/** Absolute URL for emails, JSON-LD, and Open Graph */
export function brandLogoUrl(variant = 'dark') {
  const path = variant === 'light' ? LOGO_LIGHT_SRC : LOGO_DARK_SRC;
  return absoluteUrl(path);
}

/** Dark-theme logo block for HTML emails (always absolute https://…/logo/logo-dark.png). */
export function emailLogoHtml({ height = 88 } = {}) {
  const siteUrl = getPublicSiteUrl();
  const logoUrl = brandLogoUrl('dark');
  const alt = `${SITE_NAME} logo`;
  const link = `<a href="${siteUrl}" target="_blank" rel="noopener noreferrer" style="display:inline-block;text-decoration:none;line-height:0;">
<img src="${logoUrl}" alt="${alt}" height="${height}" border="0" style="display:block;margin:0 auto;height:${height}px;width:auto;max-width:320px;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;" />
</a>`;
  return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 auto;">
<tr><td align="center" style="text-align:center;padding:0;">
${link}
</td></tr></table>`;
}
